import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Video = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 10.5914V5.40857C5.5 4.60191 6.40598 4.12722 7.06921 4.58638L10.8124 7.17781C11.3868 7.57546 11.3868 8.42454 10.8124 8.82219L7.06921 11.4136C6.40598 11.8728 5.5 11.3981 5.5 10.5914ZM9.36477 8L7 6.36285V9.63715L9.36477 8Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 13V3C1.5 2.17157 2.17157 1.5 3 1.5H13C13.8284 1.5 14.5 2.17157 14.5 3V13C14.5 13.8284 13.8284 14.5 13 14.5H3C2.17157 14.5 1.5 13.8284 1.5 13ZM3 13L3 3L13 3V13H3Z"
      fill="currentColor"
    />
  </Icon>
));

export default Video;
